/**
 * Link recipe — Chakra UI v3, aligned with NOVAHEAL UI kit (Figma).
 *
 * - **info** — Figma “Link / External” look: `text.info`, solid underline.
 * - **inline** — Figma “Link / Internal” look: `text.primary`, dashed underline.
 *
 * Sizes: sm | md → body.s / body.m regular.
 */

import { defineRecipe } from '@chakra-ui/react';

import type { RecipeVariantProps } from '@chakra-ui/react';

export const linkRecipe = defineRecipe({
  className: 'link',

  base: {
    cursor: 'pointer',
    transitionProperty: 'color, text-decoration-color',
    transitionDuration: '0.2s',
    _focusVisible: {
      outline: '2px solid',
      outlineColor: 'text.info',
      outlineOffset: '2px',
    },
  },

  variants: {
    variant: {
      info: {
        color: 'text.info',
        textDecorationStyle: 'solid',
        _hover: {
          color: 'text.info.hover',
        },
        _active: {
          color: 'text.info.active',
        },
      },
      inline: {
        color: 'text.primary',
        _hover: {
          color: 'text.secondary',
        },
        _active: {
          color: 'text.tertiary',
        },
      },
    },
    size: {
      m: {
        textStyle: 'body.s.regular',
      },
      l: {
        textStyle: 'body.m.regular',
      },
    },
  },

  defaultVariants: {
    variant: 'inline',
    size: 'l',
  },
});

export type LinkRecipeProps = RecipeVariantProps<typeof linkRecipe>;
